import { PureComponent } from 'react';
import { Button, Modal, Input } from 'antd';
import i10n from '../i10n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faCode } from '@fortawesome/free-solid-svg-icons'
import ToolService from '../services/toolsService';
import { CopyToClipboard } from '../helpers/utilities';
import { getLocalizedLink } from './tool';
import { Link } from 'react-router-dom';
import Tooltip from './tooltip';
import sitemap from '../../common/sitemap';
import { connect } from 'react-redux';
import { AsyncSVG } from './AsyncSVG';

class EmbedButtonComponent extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            needLogged: true,
            embedScript: null,
            showModal: false,
            errorMessage: null,
            copyStatus: null
        };
    }

    showEmbedScript = () => {
        this.setState({
            showModal: true
        });

        if (this.state.embedScript == null || this.state.needLogged == true) {
            var params = {
                toolName: this.props.route
            }

            ToolService.getEmbedCodeSnippet(params).then((resp) => {
                var embedScript = resp.data;

                this.setState({
                    showModal: true,
                    embedScript: embedScript,
                    needLogged: embedScript == null || embedScript == "" ? true : false,
                    errorMessage: embedScript == null || embedScript == "" ? i10n._VIEW_TOOL_LAYOUT_EMBED_WIDGET_NEED_ACCOUNT_MESSAGE : null
                });
            },
                (error) => {
                    var errorMessage = error.response?.data && typeof error.response?.data == "string" ?
                        error.response.data : error.response?.statusText || error.message;
                    this.setState({
                        showModal: true,
                        errorMessage: errorMessage,
                        needLogged: false
                    });
                });
        }
    }

    close = () => {
        this.setState({
            showModal: false
        });
    }

    copyToClipboard = () => {
        var status = null;
        CopyToClipboard(this.state.embedScript).then(() => {
            status = true;
        }).catch(() => {
            status = false;
        }).finally(() => {
            this.setState({ copyStatus: status });
            setTimeout(() => this.setState({ copyStatus: null }), 5000);
        })
    }

    render() {
        return (
            <div className="embed-button-wrapper element-with-tooltip">
                <div className="share-button" onClick={() => { this.showEmbedScript(); }}>
                    <Tooltip className="share-button-tooltip-wrapper embed-button-tooltip-wrapper" borderClassName="tooltip-border" text={i10n._VIEW_TOOL_LAYOUT_EMBED_WIDGET_TOOLTIP} />
                    <span className="share-button-label">{i10n._VIEW_TOOL_LAYOUT_EMBED_WIDGET} <FontAwesomeIcon icon={faCode} title="Share Code" /></span>
                </div>
                <Modal
                    className={`${this.props.fillClassName}`}
                    width="100%"
                    wrapClassName="embed-modal"
                    title={<p className={`${this.props.fillClassName}-embed-title`}> {i10n._VIEW_TOOL_LAYOUT_EMBED_WIDGET_TOOLTIP} </p>}
                    visible={this.state.showModal}
                    onCancel={this.close}
                    footer={!this.state.embedScript ? null : [
                        <div className="row">
                            <div className="col-12">
                                <div className="embed-copy-message">
                                    {
                                        this.state.copyStatus === true &&
                                        <span><FontAwesomeIcon color="green" icon={faCheck} size="1x" title="validate" /> {i10n._VIEW_LAYOUT_CLIPBOARD_COPY_OPERATION_SUCCESSFULL}</span>
                                    }
                                    {
                                        this.state.copyStatus === false &&
                                        <span><FontAwesomeIcon color="red" icon={faTimes} size="1x" title="validate" /> {i10n._VIEW_LAYOUT_CLIPBOARD_COPY_OPERATION_FAIL}</span>
                                    }
                                </div>

                                <Button key="1" className="ant-btn-primary" onClick={this.copyToClipboard}>
                                    {i10n._VIEW_TOOL_LAYOUT_EMBED_WIDGET_COPY_SCRIPT_BUTTON}
                                </Button>
                            </div>
                        </div>
                    ]}>
                    {
                        (!this.state.errorMessage && this.state.embedScript &&
                            <Input.TextArea ref={(area) => { this.textArea = area; }} className="embed-script" defaultValue={this.state.embedScript} readOnly={true} rows={10} />)
                        ||
                        (this.state.errorMessage && this.state.needLogged &&
                            <p>
                                {this.state.errorMessage.split('{signup}')[0]}
                                <Link className="embeded-script-link" to={getLocalizedLink(sitemap.VIEW_ACCOUNT_REGISTER_ROUTE)}>{i10n._VIEW_TOOL_LAYOUT_EMBED_WIDGET_SIGN_UP}</Link>
                                {this.state.errorMessage.split('{signup}')[1].split('{login}')[0]}
                                <Link className="embeded-script-link" to={getLocalizedLink(sitemap.VIEW_ACCOUNT_LOGIN_ROUTE)}>{i10n._VIEW_TOOL_LAYOUT_EMBED_WIDGET_LOG_IN}</Link>
                                {this.state.errorMessage.split('{signup}')[1].split('{login}')[1]}
                            </p>)
                        ||
                        (this.state.errorMessage && !this.state.needLogged &&
                            <p>{this.state.errorMessage}</p>)
                        ||
                        <div className="loading-tool">
                            <img width="" height="" alt="" src='/images/black-avepdf-svg-loading.svg'/>
                        </div>
                    }
                </Modal>
            </div>
        );
    }
}



const mapState = ({ tool }) => {
    return {
        lang: tool.lang
    };
}

const EmbedButton = connect(mapState)(EmbedButtonComponent);
export default EmbedButton;